import { createListenerMiddleware } from "@reduxjs/toolkit";
import type { RootDispatch, RootState } from "./store";

export const listenerMiddleware = createListenerMiddleware();
export const startListening = listenerMiddleware.startListening.withTypes<RootState, RootDispatch>();
